import gql from 'graphql-tag';

const CANCELLATION_POLICY = gql`
  query CancellationPolicyQuery($listingId: ID!, $checkIn: String) {
    cancellationPolicy(input: { listingId: $listingId, checkIn: $checkIn }) {
      cancellationPolicy
      deadlines {
        refundType
        refundValue
        deadlineType
        deadlineValue
        current
      }
    }
  }
`;

export const getCancellationPolicyQuery = client => (listingId, checkIn) =>
  client.query({
    query: CANCELLATION_POLICY,
    fetchPolicy: 'network-only',
    variables: {
      listingId,
      checkIn
    }
  });

const CANCELLATION_POLICIES = gql`
  query CancellationPoliciesQuery($checkIn: String, $cityId: String) {
    cancellationPolicies(input: { checkIn: $checkIn, cityId: $cityId }) {
      flexible {
        freeCancellationDeadline
        freeCancellationCurrently
        freeCancellationDeadlineType
        freeCancellationDeadlineValue
      }
      standard {
        freeCancellationDeadline
        freeCancellationCurrently
        freeCancellationDeadlineType
        freeCancellationDeadlineValue
      }
      strict {
        freeCancellationDeadline
        freeCancellationCurrently
        freeCancellationDeadlineType
        freeCancellationDeadlineValue
      }
    }
  }
`;

export const getCancellationPoliciesQuery = client => (checkIn, cityId) =>
  client.query({
    query: CANCELLATION_POLICIES,
    fetchPolicy: 'network-only',
    variables: {
      checkIn,
      cityId
    }
  });

export default {
  getCancellationPolicyQuery,
  getCancellationPoliciesQuery
};
